import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ReactLoading from "react-loading";

export default class LoadingButton extends PureComponent {
    static propTypes = {                
        text: PropTypes.string.isRequired,               
        loadingText: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        isLoading: PropTypes.bool.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        className: PropTypes.string,
    };      

    render() {        
    	const { isLoading } = this.props;
    	let buttonText = this.props.text;

    	let loadingClassName = "loading-bar";
    	if (isLoading) {
    		loadingClassName += " show";
    		buttonText = this.props.loadingText;
    	}

        return (
            <button 
                className={"btn btn-primary btn-block " + this.props.className} 
                type="submit" 
                onClick={this.props.onClick} 
                disabled={isLoading || this.props.disabled} 
                value={this.props.value}
            >
                {buttonText}
                <ReactLoading type={"bars"} height={12} width={16} className={loadingClassName} />
            </button>
        );
    }
}